import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const adminKF: AppRouteModule = {
  path: '/stat',
  name: 'Stat',
  component: LAYOUT,
  meta: {
    orderNo: -80,
    icon: 'ant-design:area-chart-outlined',
    title: '报表管理',
  },
  children: [
    {
      path: 'statParamsType',
      name: 'StatParamsType',
      component: () => import('/@/views/admin/stattemp/StatParamsType.vue'),
      meta: {
        title: '统计模版参数类型',
        icon:'ant-design:bar-chart-outlined'
      },
    },
    {
      path: 'statTemplateInst',
      name: 'StatTemplateInst',
      component: () => import('/@/views/admin/stattemp/StatTemplateInst.vue'),
      meta: {
        title: '统计模版实例',
        icon:'ant-design:exception-outlined'
      },
    },
  ],
};

export default adminKF;
